import LayoutBasic from '@/components/LayoutBasic/LayoutBasic.vue'
import { JSConn } from '@/utilities/js-conn.js'
import { TOAST_DURATION } from '@/constants'

export default {
  name: 'OtherExpenseEditForm',
  components: {
    LayoutBasic
  },
  props: ['id'],
  data () {
    return {
      otherExpenseEditItem: null,
      mode: 'edit'
    }
  },
  created () {
    if (this.id === 'new') {
      this.mode = 'new'
      this.otherExpenseEditItem = {
        description: null,
        cost: null,
        defaultQuantity: 1
      }
    } else {
      this.mode = 'edit'
      const item = this.$store.getters.getOtherExpenseItemById(this.id)
      this.otherExpenseEditItem = {...item}
    }
  },
  methods: {
    submitForm (evt) {
      evt.preventDefault()

      const jsConn = new JSConn()
      jsConn.toRoutePath = '/other-expense'
      jsConn.formParams = {
        id: this.id,
        item: this.otherExpenseEditItem
      }
      this.$store.dispatch('updateOtherExpenseItem', jsConn)
        .then((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-success',
            duration: TOAST_DURATION
          })
          this.$router.push(jsConn.toRoutePath)
        })
        .catch((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-danger',
            duration: TOAST_DURATION
          })
        })
    }
  }
}
